import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Tab, useRecordContext, useRefresh } from "react-admin";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { Student } from "../providers/studentsProvider";
import { LoadingIndicator } from "../misc/LoadingIndicator";
import { Tabs } from "../misc/Tabs";
import { grants } from "../backoffice.access_control";
import { DocumentHistoricalDrivingLessonForm } from "./DocumentHistoricalAppointmentDialog/DocumentHistoricalDrivingLessonForm";
import { DocumentHistoricalPracticalExamForm } from "./DocumentHistoricalAppointmentDialog/DocumentHistoricalPracticalExamForm";
import { DocumentHistoricalTheoryLessonForm } from "./DocumentHistoricalAppointmentDialog/DocumentHistoricalTheoryLessonForm";
import { DocumentHistoricalTheoryExamForm } from "./DocumentHistoricalAppointmentDialog/DocumentHistoricalTheoryExamForm";

export type DocumentHistoricalAppointmentTab = "drivingLesson" | "practicalExam" | "theoryLesson" | "theoryExam";

export function DocumentHistoricalAppointmentDialog({
  tabs,
  onClose,
  ...props
}: {
  open: boolean;
  onClose: () => void;
  tabs: DocumentHistoricalAppointmentTab[];
}) {
  const student = useRecordContext<Student>();
  const refresh = useRefresh();
  const effectiveTabs = tabs.filter((tab) => {
    if (tab === "drivingLesson") {
      return grants.has("DrivingLesson:historical:create");
    }
    if (tab === "theoryLesson") {
      return grants.has("TheoryLesson:historical:create");
    }
    return grants.has("Exam:historical:create");
  });

  const onSuccess = () => {
    refresh();
    onClose();
  };

  const formForTab = (tab: DocumentHistoricalAppointmentTab) => {
    if (!student) {
      return <LoadingIndicator />;
    }
    if (tab === "drivingLesson") {
      return <DocumentHistoricalDrivingLessonForm student={student} onSuccess={onSuccess} />;
    }
    if (tab === "practicalExam") {
      return <DocumentHistoricalPracticalExamForm student={student} onSuccess={onSuccess} />;
    }
    if (tab === "theoryLesson") {
      return <DocumentHistoricalTheoryLessonForm student={student} onSuccess={onSuccess} />;
    }
    return <DocumentHistoricalTheoryExamForm student={student} onSuccess={onSuccess} />;
  };

  const tabLabel = (tab: DocumentHistoricalAppointmentTab) => {
    if (tab === "drivingLesson") return "Fahrstunde";
    if (tab === "practicalExam") return "Praktische Prüfung";
    if (tab === "theoryLesson") return "Theoriestunde";
    return "Theorieprüfung";
  };

  return (
    <Dialog open={props.open} fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle>Termin dokumentieren von {student?.name}</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        {student ? (
          effectiveTabs.length === 1 ? (
            formForTab(effectiveTabs[0])
          ) : effectiveTabs.length > 1 ? (
            <Tabs sx={{ m: 0 }} syncWithLocation={false}>
              {effectiveTabs.map((tab) => (
                <Tab key={tab} label={tabLabel(tab)}>
                  {formForTab(tab)}
                </Tab>
              ))}
            </Tabs>
          ) : null
        ) : (
          <LoadingIndicator />
        )}
      </DialogContent>
    </Dialog>
  );
}
